package core.validation

enum class EsInputState {
    Default,
    Loading,
    Error,
    Success,
    ;

    val isError: Boolean
        get() = this == Error

    val isValid: Boolean
        get() = this == Default || this == Success
}
